<ngxh6-bool-yes-no [ngbTooltip]="job.referredToDipl ? 'Job is referred to DIPL' : null" [value]="job.referredToDipl"></ngxh6-bool-yes-no>
